import React from 'react'

const PresentationContext = React.createContext(null)
const PresentationStateContext = React.createContext(null)

export { PresentationContext, PresentationStateContext }
